import { DimensionContext } from "@src/DimensionProvider";
import images from "@assets/images";
import { ImageButton06 } from "components/button";
import React, { useContext } from "react";
import { Image, View } from "react-native";
import { AvatarContext } from "../AvatarProvider";
import useStyles from "./styles.css";
import TierLevelItem from "./tier-level-item";

const TierLevel = () => {
  const styles = useStyles();
  const { setShowScreen } = useContext(AvatarContext);
  const { baseWidth } = React.useContext(DimensionContext);

  return (
    <View style={[styles.container]}>
      <View style={[styles.bodyStyle, { height: baseWidth * 0.4583} ]}>
        <Image
          style={styles.i_bg}
          resizeMode="stretch"
          source={{uri: images.bg_transparent}}
        />
        <View style={[styles.v_bg]}>
          <View style={styles.v_center_tier}>
            <Image
              style={[styles.i_tier_rewards]}
              source={{uri: images.tier_rewards}}
              resizeMode="stretch"
            />
            <View style={styles.v_tier_banner}>
              <TierLevelItem
                title="COPPER"
                access="Entry Level"
                baseWidth={baseWidth}
                source={images.Player_level_Cooper}
                bonus="None"
              />
              <Image
                style={[styles.i_tier_arrow]}
                source={{uri: images.tier_arrow1}}
                resizeMode="stretch"
              />
              <TierLevelItem
                title="BRONZE"
                baseWidth={baseWidth}
                source={images.Player_level_Bronze}
                access={"Prime Games"}
                bonus="3,000,000"
              />
              <Image
                style={[styles.i_tier_arrow]}
                source={{uri: images.tier_arrow2}}
                resizeMode="stretch"
              />
              <TierLevelItem
                title="SILVER"
                baseWidth={baseWidth}
                source={images.Player_level_Silver}
                access={"Premium Games"}
                bonus="10,000,000"
              />
              <Image
                style={[styles.i_tier_arrow]}
                source={{uri: images.tier_arrow3}}
                resizeMode="stretch"
              />
              <TierLevelItem
                title="GOLD"
                baseWidth={baseWidth}
                source={images.Player_level_Gold}
                access={"VIP Games"}
                bonus="17,000,000"
              />
            </View>
            <ImageButton06
              style={[
                styles.btn_back,
                { height: baseWidth * 0.05, width: baseWidth * 0.15 },
              ]}
              source={images["btn-big"]}
              label="BACK TO PROFILE"
              labelStyle={{fontSize: baseWidth * 0.012}}
              onPress={() => setShowScreen("")}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default React.memo(TierLevel);
